(function() {
  function waitForjQuery(trigger, delayInterval, delayTimeout) {
    var intervalForjQuery = setInterval(function() {
      if (typeof window.jQuery != 'undefined') {
        clearInterval(intervalForjQuery);
        trigger();
      }
    }, delayInterval);
    var timeoutForjQuery = setTimeout(function() {
      clearInterval(intervalForjQuery);
    }, delayTimeout);
  }

  waitForjQuery(function() {
    var $ = window.jQuery;
    $(document).ready(function(){

    // Remaining character
    $('.bm-gift-message-note textarea#note').on("input", function() {
      var maxlength = $(this).attr("maxlength");
      var currentLength = $(this).val().length;
      if (currentLength >= maxlength) {
        return $(".bm-gift-remaining-character span").text("0");
      }
      $(".bm-gift-remaining-character span").text(maxlength - currentLength);
    });

    var maxlength = $(".bm-gift-message-note textarea#note").attr("maxlength");
    var currentLength = $(".bm-gift-message-note textarea#note").val().length;
    if (currentLength >= maxlength) {
      return $(".bm-gift-remaining-character span").text("0");
    }
    $(".bm-gift-remaining-character span").text(maxlength - currentLength);

    // close popup
    $(".bm-gift-options-close").click(function(){
        $(".bm-gift-options-popup").removeClass("bm-gift-popup-show");
        $("body").removeClass("bm-gift-popup-open");
      
        // remove blank cart note
        if($(".bm-gift-message-product").length == 0) {
          $(".bm-gift-message-note textarea#note").val("");
        }
    });
    $(document).click(function (e) {
    if (!$(e.target).parents().addBack().is('.bm-js-gift-message')) {
        $(".bm-gift-options-popup").removeClass("bm-gift-popup-show");
        $("body").removeClass("bm-gift-popup-open");
        if ($(".bm-gift-message-product").length || $(".bm-luxury-giftcard-product").length) {
           $('input#bm-gift-message').prop("checked", true);
        }else {
          $('input#bm-gift-message').prop("checked", false);
        }
        // remove blank cart note
        if($(".bm-gift-message-product").length == 0) {
          $(".bm-gift-message-note textarea#note").val("");
        }
    }
    });
    $(".bm-gift-options-popup-main").click(function (e) {
        e.stopPropagation();
    });

    
    $(function () {
        // checked checkbox when write message
        $('.bm-gift-message-note #note').on('keyup', function () {
            $('.bm-gift-popup-message .bm-product-info-head.bm-gift-checked input').prop('checked', true);
            $('.bm-gift-popup-message .bm-product-info-head.bm-luxury-checked input').prop("checked", false);
            $('.bm-gift-popup-message .bm-product-info-head.bm-gift-checked').removeClass("bm-gift-remember");
            $('.bm-gift-popup-message .bm-product-info-head.bm-luxury-checked').addClass("bm-luxury-remember");
            $(".bm-gift-popup-message .bm-product-info-head.bm-luxury-checked").parent().addClass("bm-luxury-remember-top");
            $(".bm-gift-popup-product-info").removeClass("bm-gift-remember-show");
            $(".bm-gift-popup-product-info").removeClass("bm-gift-remember-top");
            if($(this).val().length){
              $(".bm-button-save").addClass("bm-button-saveactive");
              $(".bm-button-save").addClass("bm-button-saveauto");
            } else {
              $(".bm-button-save").removeClass("bm-button-saveactive");
              $(".bm-button-save").removeClass("bm-button-saveauto");
            }
        });

      
        $('.bm-gift-popup-message .bm-gift-checked ').click(function(){
          var updategiftBoxes = $('.bm-gift-popup-message .bm-product-info-head.bm-gift-checked input');
          updategiftBoxes.prop("checked", !updategiftBoxes.prop("checked"));
          $(".bm-gift-popup-message .bm-product-info-head.bm-luxury-checked").toggleClass("bm-luxury-remember");
          $(".bm-gift-popup-message .bm-product-info-head.bm-luxury-checked").parent().toggleClass("bm-luxury-remember-top");
            $(".bm-button-save").removeClass("bm-button-saveactive");
          $(".bm-gift-popup-product-info").removeClass("bm-luxury-remember-show");
          if($(".bm-gift-message-note #note").val().length){
              $(".bm-button-save").addClass("bm-button-saveauto");
            } else {
              $(".bm-button-save").removeClass("bm-button-saveauto");
            }
        });

        $(".bm-gift-popup-message .bm-luxury-checked ").click(function(){
          var updategiftBoxes = $('.bm-gift-popup-message .bm-product-info-head.bm-luxury-checked input');
          updategiftBoxes.prop("checked", !updategiftBoxes.prop("checked"));
          $('.bm-gift-popup-message .bm-product-info-head.bm-gift-checked').toggleClass("bm-gift-remember");
          
          $(".bm-gift-popup-message .bm-product-info-head.bm-gift-checked").parent().toggleClass("bm-gift-remember-top");
          $('.bm-gift-message-note').toggleClass("bm-gift-remember-top");
          if ($(".bm-button-save").hasClass("bm-button-saveactive")) {
            $(".bm-button-save").removeClass("bm-button-saveactive");
          } else {
            $(".bm-button-save").addClass("bm-button-saveactive");
          }
          $(".bm-gift-popup-product-info").removeClass("bm-gift-remember-show");
          $(".bm-gift-message-note").removeClass("bm-gift-remember-show");
        });
        $('.bm-gift-popup-message .bm-gift-checked input').click(function(){
          var updategiftBoxes = $('.bm-gift-popup-message .bm-product-info-head.bm-gift-checked input');
          updategiftBoxes.prop("checked", !updategiftBoxes.prop("checked"));
          if ($(".bm-button-save").hasClass("bm-button-saveactive")) {
            $(".bm-button-save").addClass("bm-button-saveactive");
          } else {
            $(".bm-button-save").removeClass("bm-button-saveactive");
          }
        });

        $(".bm-gift-popup-message .bm-luxury-checked input").click(function(){
          var updategiftBoxes = $('.bm-gift-popup-message .bm-product-info-head.bm-luxury-checked input');
          updategiftBoxes.prop("checked", !updategiftBoxes.prop("checked"));
          if ($(".bm-button-save").hasClass("bm-button-saveactive")) {
            $(".bm-button-save").addClass("bm-button-saveactive");
          } else {
            $(".bm-button-save").removeClass("bm-button-saveactive");
          }
        });
    });
    
    // checked if cart has any gift product
    if ($(".bm-gift-message-product").length || $(".bm-luxury-giftcard-product").length) {
      let bmgiftmessagetwo = $(".bm-gift-message-two").text();
      $(".bm-gift-message label").text(bmgiftmessagetwo);
       $('.bm-gift-message input').prop("checked", true);
    }

    // Default select option
    if ($(".bm-gift-message-product").length) {
       $('.bm-gift-popup-message .bm-product-info-head.bm-gift-checked input').prop('checked', true);
       $('.bm-gift-popup-message .bm-product-info-head.bm-luxury-checked').addClass("bm-luxury-remember");
       $(".bm-gift-popup-message .bm-product-info-head.bm-luxury-checked").parent().addClass("bm-luxury-remember-top");
       $(".bm-button-save").addClass("bm-button-saveactive");
       $(".bm-button-save").addClass("bm-button-saveauto");
    }
    if ($(".bm-luxury-giftcard-product").length) {
      $('.bm-gift-popup-message .bm-product-info-head.bm-luxury-checked input').prop("checked", true);
      $('.bm-gift-popup-message .bm-product-info-head.bm-gift-checked').addClass("bm-gift-remember");
      $(".bm-gift-popup-message .bm-product-info-head.bm-gift-checked").parent().addClass("bm-gift-remember-top");
      $(".bm-button-save").addClass("bm-button-saveactive");
      $(".bm-gift-message-note").addClass("bm-gift-remember-top");
      $(".bm-button-save").addClass("bm-button-saveauto");
    }

    // show remember message 
    $(".remember-messages-box").click(function(){
      $(".bm-luxury-remember-top").addClass("bm-luxury-remember-show");
      $(".bm-gift-remember-top").addClass("bm-gift-remember-show");
      // Hide Remember message after  5sec
      function hideMessage() {
        $(".bm-luxury-remember-top").removeClass("bm-luxury-remember-show");
        $(".bm-gift-remember-top").removeClass("bm-gift-remember-show");
      }
      setTimeout(hideMessage, 3000);
    });

    // cart product click prevent
    $('body').on('click', '.bm-gift-message-prod-dr a', function(e) {
        e.preventDefault();
        console.log('>> gift-message');
    });
    $('body').on('click', '.bm-luxury-giftcard-prod-dr a', function(e) {
        e.preventDefault();
        console.log('>> gift-cart');
    });

    // Gift meassage added content
    let bmgiftmessagecontent = '<div class="bm-giftmessage-content"><span>Your Gift Message Has Been Included!</span><div class="product-delete"><small>Remove</small></div></div>'
    $('.cart__card.container.is-align-center.bm-cart-items.bm-gift-message-product').html(bmgiftmessagecontent);
    $('.cart__item-list.ten.column').prepend($('.bm-cart-items.bm-gift-message-product'));
    $('.cart__item-list.ten.column').prepend($('.bm-cart-items.bm-luxury-giftcard-product'));

    // Remove product from cart
    $('.bm-gift-message-prod-dr .product-minus.js-change-quantity').click(function() {
      $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {note: ''},
          dataType: 'json',
          success: function() {
            $('.bm-giftmessage-content small').click();
          }
        });
    });
    
    // Remove Cart Nore when click remove btn
    $('.bm-giftmessage-content small').click(function() {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {note: ''},
          dataType: 'json',
          success: function() {
            $.ajax({
              type: 'POST',
              url: '/cart/change.js',
              data: {
                id: 41577219391671,
                quantity: 0
              },
              dataType: 'json',
              success: function() { 
                location.reload();
                window.scrollTo(0, 0);
              }
            });
          }
        });
    });

    // ATC button 
    $('.bm-button-save span').click(function() {
      
      // product remove from cart if nothing is selected
        if ($('.bm-gift-checked .bm-product-id-check').is(':checked') == false && $('.bm-luxury-checked .bm-product-id-check').is(':checked') == false ) {
          console.log("yes");
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: {note: ''},
            dataType: 'json',
            success: function() {
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                  id: 41577219391671,
                  quantity: 0
                },
                dataType: 'json',
                success: function() { 
                  $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: {
                    id: 41577229385911,
                    quantity: 0
                  },
                  dataType: 'json',
                  success: function() { 
                    window.scrollTo(0, 0);
                    location.reload();
                  }
                });
                }
              });
            }
          });
          
          
        } else {
          window.scrollTo(0, 0);
          console.log("no");
          var giftProducts = [];
          var haveGiftMessage = false;
          var haveGiftCard = false;
          var productAdd = [];
          var productRemove = [];
          var cartMessage = $(".bm-gift-message-note textarea#note").val();
    
          // add gift products to array
          $('.bm-product-id-check').each(function(){
            var id = $(this).data('id');
            var type = 'gift-card';
            if($(this).hasClass('gift-message')) {
              type = 'gift-message';
            }
            giftProducts.push({id: id, type: type});
          })
    
          // check available products in cart
          $('.bm-cart-items').each(function(){
            if($(this).hasClass('bm-gift-message-product')) {
              haveGiftMessage = true;
            }
            if($(this).hasClass('bm-luxury-giftcard-product')) {
              haveGiftCard = true;
            }
          });
    
          // generate product list need to add/remove
          $('.bm-product-id-check').each(function() {
            if ($(this).is(':checked')) {
              var id = $(this).data('id');
              var type = 'gift-card';
              if($(this).hasClass('gift-message')) {
                type = 'gift-message';
              }
              
              if(type == 'gift-message') {
                if(!haveGiftMessage) {
                  productAdd.push({id: id, quantity: 1});
    
                  if(haveGiftCard) {
                    var prod = giftProducts.filter(function(item) {
                      return item.type == 'gift-card';
                    });
                    productRemove.push({id: prod[0].id, quantity: 0});
                  }
                }
              } else {
                if(haveGiftMessage) {
                  var prod = giftProducts.filter(function(item) {
                    return item.type == 'gift-message';
                  });
                  productRemove.push({id: prod[0].id, quantity: 0});
                }
                if(!haveGiftCard) {
                  productAdd.push({id: id, quantity: 1});
                }
                cartMessage = '';
              }
            }
          });
    
          updateProducts(productAdd, productRemove, cartMessage);
        }
        // add or remove gift product to cart
        function updateProducts(productAdd, productRemove, cartMessage) {
          if(productAdd.length && productRemove.length) {
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {items: productAdd, note: cartMessage},
              dataType: 'json',
              success: function() {
                $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: {
                    id: productRemove[0].id,
                    quantity: 0
                  },
                  dataType: 'json',
                  success: function() { 
                    location.reload();
                  }
                });
              }
            });
          } else if(productAdd.length) {
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: {items: productAdd, note: cartMessage},
              dataType: 'json',
              success: function() { 
                location.reload();
              }
            });
          } else {
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: {note: cartMessage},
              dataType: 'json',
              success: function() {
                location.reload();
              }
            });
          }
        }

    });


    
 
  });
  }, 50, 10000);
})();
  
